import { EEnvLocale } from '../env.types';

export const DEFAULT_LANGUAGE = EEnvLocale.fr;
